import { Alert, Snackbar } from "@mui/material";
import theme from "../theme";
interface ToastMsgType {
  open: boolean;
  handleClose?: (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
  message?: string;
}

const ToastMsg: React.FC<ToastMsgType> = (props) => {
  const { open, handleClose, message } = props;
  return (
    <div>
      <Snackbar
        sx={{
          width: "100%",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        ContentProps={{
          sx: {
            textAlign: "center",
          },
        }}
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
      >
        <Alert
          severity="success"
          sx={{
            // width: "300px",
            paddingLeft: "50px",
            paddingRight: "50px",
            backgroundColor: theme.color.green_500,
            "& .MuiAlert-message": {
              textAlign: "center",
              width: "inherit",
              color: theme.color.white,
              fontWeight: 700,
            },
            "& .MuiSvgIcon-root": {
              fill: theme.color.white,
            },
          }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ToastMsg;
